import { AbstractTracker } from '../../../internal/platformMetrics/aggregators/AbstractTracker';
class WeightCounter extends AbstractTracker {
    track(id, weight) {
        var _this_eventData, _id;
        var _;
        (_ = (_this_eventData = this.eventData)[_id = id]) !== null && _ !== void 0 ? _ : _this_eventData[_id] = 0;
        this.eventData[id] += weight;
    }
}
export { WeightCounter as default };

//# sourceMappingURL=WeightCounter.js.map